import { DocumentNode } from 'graphql';
import {
  gql, QueryHookOptions, useLazyQuery, useQuery,
} from '@apollo/client';
import { IKeywordClassificationSchemaPartial, IKeywordClassificationSchema } from '../../type/keywordClassification';
import { IWithPagination, DeepPartial } from '../_module/baseQueryType';


export interface IKeywordClassificationQuerySearchInfo {
  searchInfo: {
    groupByAlphabetInfo: {
      key: string
      count: number
    }[];
  }
}



export interface IKeywordClassificationVars {
  
 filter: {
  _id?: string;
  _ids?: string[];
  slug?: string;
  status?: boolean;
}
 sort: {
  _id?: number;
  name?: number;
  updatedTime?: number;
  createdTime?: number;
}
 search: {
  _id?: string;
  name?: string;
  nameStartWith?: string;
}
 skip?: number
 limit?: number
 
  
  
  
  
 
}
export const KeywordClassificationQueryTypeDefinitionKey = 'KeywordClassification';
export type IKeywordClassificationVarsPartial = Partial<IKeywordClassificationVars>
export type IKeywordClassificationDataPartial = DeepPartial<IKeywordClassificationSchemaPartial>
export interface IKeywordClassificationQueryData<TData extends IKeywordClassificationSchema = IKeywordClassificationSchema>{
  

    keywordClassifications: IWithPagination<TData> & IKeywordClassificationQuerySearchInfo
}

export function keywordClassificationQuery(fragment: string, rootFragment?: string, withPagination?: boolean): DocumentNode {
  return gql`
        query 

    keywordClassifications(
        $filter: KeywordClassificationQueryFilterParameterInput,
$search: KeywordClassificationQuerySearchParameterInput,
$sort: KeywordClassificationQuerySortParameterInput,
$skip: Int,
$limit: Int
        ){
        

    keywordClassifications(
        filter: $filter,
search: $search,
sort: $sort,
skip: $skip,
limit: $limit
        ){
          items {
              ${fragment}
          }
          ${withPagination ? `
          pagination {
            total
            perPage
            currentPage
            hasNextPage
            totalPage
          }
          ` : ''}
          ${rootFragment || ''}
        }
        }
    `;
}

export function useKeywordClassificationLazyQuery<TData extends IKeywordClassificationSchema>(
  fragment: string,
  options?: QueryHookOptions<IKeywordClassificationQueryData<TData>, IKeywordClassificationVarsPartial>,
  rootFragment?: string,
  withPagination?: boolean
) {
  return useLazyQuery<IKeywordClassificationQueryData<TData>, IKeywordClassificationVarsPartial>(keywordClassificationQuery(fragment, rootFragment, withPagination), options);
}

export function useKeywordClassificationQuery<TData extends IKeywordClassificationSchema>(
  fragment: string,
  options?: QueryHookOptions<IKeywordClassificationQueryData<TData>, IKeywordClassificationVarsPartial>,
  rootFragment?: string,
  withPagination?: boolean
) {
  return useQuery<IKeywordClassificationQueryData<TData>, IKeywordClassificationVarsPartial>(keywordClassificationQuery(fragment, rootFragment, withPagination), options);
}
